export default {
    "name": "GetAccommodationAvailabilities",
    "kind": "HoudiniQuery",
    "hash": "41c391e9a5cd1be6c56535d5d8b1d9209672911da5f995c623151dd9aa5615e6",

    "raw": `query GetAccommodationAvailabilities($input: GetAccommodationAvailabilitiesInput!) {
  getAccommodationAvailabilities(input: $input) {
    availabilityStatusCode
    availableRoomsCount
    availableRoomsPrices
    bookDeepLink
    bookUrl
    currency
    highlightedRoomsPrices
    id
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getAccommodationAvailabilities": {
                "type": "GetAccommodationAvailabilitiesResult",
                "keyRaw": "getAccommodationAvailabilities(input: $input)",

                "selection": {
                    "fields": {
                        "availabilityStatusCode": {
                            "type": "AvailabilityStatusCode",
                            "keyRaw": "availabilityStatusCode",
                            "nullable": true,
                            "visible": true
                        },

                        "availableRoomsCount": {
                            "type": "Int",
                            "keyRaw": "availableRoomsCount",
                            "visible": true
                        },

                        "availableRoomsPrices": {
                            "type": "Float",
                            "keyRaw": "availableRoomsPrices",
                            "visible": true
                        },

                        "bookDeepLink": {
                            "type": "String",
                            "keyRaw": "bookDeepLink",
                            "visible": true
                        },

                        "bookUrl": {
                            "type": "String",
                            "keyRaw": "bookUrl",
                            "visible": true
                        },

                        "currency": {
                            "type": "String",
                            "keyRaw": "currency",
                            "visible": true
                        },

                        "highlightedRoomsPrices": {
                            "type": "Float",
                            "keyRaw": "highlightedRoomsPrices",
                            "visible": true
                        },

                        "id": {
                            "type": "String",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "GetAccommodationAvailabilitiesInput"
        },

        "types": {
            "GetAccommodationAvailabilitiesInput": {
                "checkin": "String",
                "checkout": "String",
                "guestsCount": "Int",
                "id": "String",
                "platform": "BookingPlatform",
                "roomsCount": "Int"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=3e59cf80ac71a5cf3cc7030d251fce48052a7510096ac010d4fc73cfca1e5971";